import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrInitialCausality } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';
import { ISelect } from '../../../../../../shared/types/shared';

export const usePqrInitialCausality = (
    initialCausality?: PqrInitialCausality
) => {
    const formik = useFormik({
        initialValues: {
            product: '',
            motive: '',
            submotive1: '',
            submotive2: '',
            submotive3: '',
            submotive4: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const motiveId = (initialCausality?.motive as ISelect)?.id;
        const sub1 = initialCausality?.submotive1 as ISelect | undefined;
        const sub2 = initialCausality?.submotive2 as ISelect | undefined;
        const sub3 = initialCausality?.submotive3 as ISelect | undefined;
        const sub4 = initialCausality?.submotive4 as ISelect | undefined;

        const submotive1 =
            sub1?.parent?.id && motiveId && sub1.parent.id === motiveId
                ? sub1
                : 'N/A';

        const submotive2 =
            submotive1 !== 'N/A' &&
            sub2?.parent?.id &&
            sub1?.id &&
            sub2.parent.id === sub1.id
                ? sub2
                : 'N/A';

        const submotive3 =
            submotive2 !== 'N/A' &&
            sub3?.parent?.id &&
            sub2?.id &&
            sub3.parent.id === sub2.id
                ? sub3
                : 'N/A';

        const submotive4 =
            submotive3 !== 'N/A' &&
            sub4?.parent?.id &&
            sub3?.id &&
            sub4.parent.id === sub3.id
                ? sub4
                : 'N/A';

        formik.setValues({
            product: useGetNameOrValue(initialCausality?.product || ''),
            motive: useGetNameOrValue(initialCausality?.motive || ''),
            submotive1: useGetNameOrValue(submotive1),
            submotive2: useGetNameOrValue(submotive2),
            submotive3: useGetNameOrValue(submotive3),
            submotive4: useGetNameOrValue(submotive4),
        });
    }, [initialCausality]);

    return {
        formik,
    };
};
